import axiosInstance from './axios';

const MiscAPI = {

    // every listing form: the fields, choices and checkboxes of each listing type and property type
    getListingForms : (lang) => {
        return axiosInstance.get(`listing_forms/${lang}`, { });
    },

    //----------------------------------------------------------------
  
    getPropertyTypeOptions : (lang) => {
         return axiosInstance.get(`property_type/${lang}`, { });
    },

    //----------------------------------------------------------------
  
    getUserTypeOptions : (lang) => {
            return axiosInstance.get(`user_type/${lang}`, { });
       },

    //----------------------------------------------------------------
  
    getListingTypeOptions : (lang) => {
        return axiosInstance.get(`listing_type/${lang}`, { });
   }
}

export default MiscAPI;